module.exports = __webpack_public_path__ + "img/ppt.144128b9.svg";